// The table's filters and sort as the URL's search: codes only, never free text (docs/CONTRACTS.md section 5).
// No imports, so the route entry (loaded with the shell) stays small; the screens load as their own chunks.

export const SORTS = ['potential', 'name', 'size'] as const
export const SIZES = ['micro', 'small', 'medium', 'large'] as const
export const STAGES = ['new', 'watch', 'active', 'parked', 'customer', 'closed'] as const

/** The table's filters and sort. They are the URL's search (codes only, never free text). */
export interface OrgFilters {
  sort?: (typeof SORTS)[number]
  industry?: string
  place?: string
  size?: (typeof SIZES)[number]
  stage?: (typeof STAGES)[number]
}

const oneOf = <T extends string>(list: readonly T[], v: unknown): T | undefined => (typeof v === 'string' && (list as readonly string[]).includes(v) ? (v as T) : undefined)
/** The router reads a bare `industry=23` as the number 23 (and writes the string "23" quoted); both give the code '23'. */
const code = (re: RegExp, v: unknown): string | undefined => {
  const text = typeof v === 'number' ? String(v) : v
  return typeof text === 'string' && re.test(text) ? text : undefined
}

/** Router validateSearch: keeps only the filter codes this screen knows, in their valid form. */
export function parseFilters(search: Record<string, unknown>): OrgFilters {
  const out: OrgFilters = {}
  const sort = oneOf(SORTS, search.sort)
  const industry = code(/^\d{2}(?:\.\d{1,3})?$/, search.industry)
  const place = code(/^\d{4}$/, search.place)
  const size = oneOf(SIZES, search.size)
  const stage = oneOf(STAGES, search.stage)
  if (sort) out.sort = sort
  if (industry) out.industry = industry
  if (place) out.place = place
  if (size) out.size = size
  if (stage) out.stage = stage
  return out
}
